import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "detail-status-container"
};
const _hoisted_2 = {
  key: 0,
  class: "status-dots-container"
};
const _hoisted_3 = {
  class: "status-time-labels"
};
const _hoisted_4 = {
  class: "status-time"
};
const _hoisted_5 = {
  class: "test-agent"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 0,
  class: "curr-dot"
};
const _hoisted_8 = {
  class: "status-detail"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  class: "markdown-log"
};
const _hoisted_11 = {
  class: "log-brief-data"
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 1,
  class: "args-wrap"
};
const _hoisted_14 = {
  class: "arg-item-value"
};
const _hoisted_15 = {
  class: "brief-item"
};
const _hoisted_16 = ["innerHTML"];
const _hoisted_17 = {
  key: 0,
  class: "log-table"
};
const _hoisted_18 = {
  class: "rest-key"
};
const _hoisted_19 = {
  key: 1,
  class: "xml-data"
};
const _hoisted_20 = {
  key: 1
};
const _hoisted_21 = ["innerHTML"];
const _hoisted_22 = {
  key: 2
};
const _hoisted_23 = {
  key: 3
};
const _hoisted_24 = {
  key: 4
};
import { onMounted, ref, toRefs, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { formatInTimeZone } from 'date-fns-tz';
import { format, add } from 'date-fns';
import XmlViewer from 'vue3-xml-viewer';
import { useUserDefaultSettingStore } from '@/store/user';
import { useStatusStore } from '@/store/status';
import { useDetailStatusStore } from '@/store/detailStatus';
import { mctRequest } from '@/api/axios';
import { deepClone, getNumberFromStr } from '@/utils/util';
import { groupListApi } from '@/api/agents/cloudAgents';
import CheckNameAndOwner from './CheckNameAndOwner.vue';
import DownloadAndShareInfo from './DownloadAndShareInfo.vue';
import DialogHeader from '@/components/dialog-header/index.vue';
import Incident from './Incident.vue';
import Issue from './Issue.vue';
import IncidentTable from './IncidentTable.vue';
import IssueTable from './IssueTable.vue';
import PagerDutyTable from './PagerDutyTable.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    statusId: {
      default: 0
    },
    isManual: {
      type: Boolean,
      default: false
    }
  },
  emits: ["changeUrlId"],
  setup(__props, {
    emit: __emit
  }) {
    const userDefaultSettingStore = useUserDefaultSettingStore();
    const {
      timeZone,
      privilege
    } = storeToRefs(userDefaultSettingStore);
    const statusStore = useStatusStore();
    const {
      clickZoneType,
      timePos,
      serverId
    } = storeToRefs(statusStore);
    const detailStatusStore = useDetailStatusStore();
    const {
      isShowDetailStatus,
      selectedFailedDot,
      incidentTicket,
      issueTicket,
      incIssueNote,
      markDownLog,
      incidentDialogVisible,
      issueDialogVisible,
      checkStatus,
      isManualTestDetail,
      manuelTestDetailDate
    } = storeToRefs(detailStatusStore);
    const props = __props;
    const {
      statusId,
      isManual
    } = toRefs(props);
    const emits = __emit;
    const loading = ref(false);
    const currTabIndex = ref('FormattedLog');
    const handleSelect = key => {
      currTabIndex.value = key;
    };
    const statusDots = ref({});
    const agentList = ref();
    const getGoupListApi = async () => {
      if (agentList.value?.length) {
        return;
      }
      const {
        gAgentOrgs
      } = await groupListApi('');
      if (Array.isArray(gAgentOrgs)) {
        agentList.value = gAgentOrgs;
      }
    };
    const getStatusDetailByManualId = async () => {
      const config = {
        url: `/clusterlist/status/manual/${statusId.value}`
      };
      const {
        result
      } = await mctRequest.request(config);
      // for sharing
      result.statusFail = true;
      getStatusMonitorResult(result);
    };
    const getDetailStatusDots = async () => {
      const utcTime = formatInTimeZone(timePos.value * 1000, 'UTC', 'yyyy-MM-dd HH:mm:ss');
      const config = {
        url: encodeURI(statusId.value !== 0 ? `/clusterlist/status/oneHour/${statusId.value}` : `/clusterlist/status/oneHour/${serverId.value}/${utcTime}/0`)
      };
      const {
        statusDetailList
      } = await mctRequest.request(config);
      const res = {};
      const agent = [[], [], [], [], [], []];
      selectedFailedDot.value = null;
      let lastFailedDot = null;
      for (let i = 0, len = statusDetailList?.length; i < len; i++) {
        const item = statusDetailList[i];
        if (statusId.value && statusId.value === item.statusId) {
          selectedFailedDot.value = item;
        }
        if (item.timeshow === timePos.value * 1000) {
          selectedFailedDot.value = item;
        }
        if (item.statusFail) {
          lastFailedDot = item;
        }
        if (i === len - 1 && !selectedFailedDot.value) {
          selectedFailedDot.value = lastFailedDot;
        }
        const tenMinutes = /.+:(\d)\d:.+/;
        // @ts-ignore
        const index = tenMinutes.exec(item.dbtime)?.[1] || '0';
        const target = agentList.value.find(agent => agent.vGroupId?.toString() === item.sourceId?.toString());
        const agentLocation = target.orgName;
        if (!res[agentLocation]) {
          res[agentLocation] = deepClone(agent);
        }
        res[agentLocation][parseInt(index)].push(item);
      }
      // if (!selectedFailedDot.value) {
      //   selectedFailedDot.value = statusDetailList.at(-1)
      // }
      statusDots.value = res;
      getStatusMonitorResult(selectedFailedDot.value);
    };
    const changeDot = dot => {
      !isManual.value && emits('changeUrlId', dot.statusId);
      getStatusMonitorResult(dot);
    };
    const dotColorMap = {
      0: 'mct-bg-grey',
      1: 'mct-bg-green',
      2: 'mct-bg-blue',
      3: 'mct-bg-yellow pointer',
      4: 'mct-bg-red pointer',
      5: 'mct-bg-red1 pointer',
      6: 'mct-bg-red2 pointer',
      7: 'mct-bg-violet pointer'
    };
    const checkName = ref('');
    const clusterId = ref('');
    const clusterName = ref('');
    const currServerId = ref(0);
    const gmtStatusTime = ref('');
    const shareLink = ref('');
    const statusTimeLabel = ref('');
    const currDotTime = ref('');
    const markDownLogDescription = ref('');
    const traceLog = ref('');
    const runBook = ref('');
    const serverType = ref(0);
    const serverTypeName = ref('');
    const zoneId = ref(0);
    const origin = window.location.origin;
    const getStatusMonitorResult = async dot => {
      if (!dot?.statusFail) {
        return;
      }
      if (serverId.value === 0 && currServerId.value !== dot.serverId) {
        currServerId.value = dot.serverId;
      }
      shareLink.value = `${origin}/detail-status/${dot.statusId}`;
      loading.value = true;
      dot.statusFlag = dot?.statusFlag || 0;
      if (isManualTestDetail.value || isManual.value) {
        shareLink.value += '?isManual=true';
        dot.statusFlag = 1;
      }
      const zonetype = isManualTestDetail.value ? dot.zoneType : clickZoneType.value;
      const config = {
        url: `/detailstatus/detailStatusQuery?zonetype=${zonetype}&status=${dot.serverStatus}&serverID=${dot.serverId}&statusID=${dot.statusId}&statusFlag=${dot.statusFlag}&serverType=${dot.serverType}&timeZone=${timeZone.value}`,
        noLoading: true
      };
      const data = await mctRequest.request(config);
      loading.value = false;
      checkName.value = data.hostname;
      checkStatus.value = data;
      const server = data.oneServer;
      clusterId.value = server.clusterId.toString();
      clusterName.value = server.clusterName;
      gmtStatusTime.value = server.gmtStatusTime;
      serverType.value = server.serverType;
      serverTypeName.value = server.serverTypeName;
      zoneId.value = server.zoneId;
      // change selected dot
      selectedFailedDot.value = dot;
      // fill the time of selected dot
      const dotTime = /(.+?):.+/.exec(data.statusTime) || [];
      statusTimeLabel.value = `${dotTime[1]}:00 (UTC+${timeZone.value})`;
      currDotTime.value = `${dotTime[0]}`;
      // fill the runbook
      runBook.value = data?.pluginServerMemo || 'there is no runbook for this check';
      // fill the monitor result
      let monitorResult = '';
      for (const item of data.listDetailStatus) {
        monitorResult += item.comments;
      }
      monitorResult = removeStyle(monitorResult);
      // console.log('monitorResult1111', monitorResult)
      const formattedLogRegex = />{8}mct_monitor_formatted_log_begin[\s\S]*?mct_monitor_formatted_log_end<<<<<<<</g;
      if (formattedLogRegex.test(monitorResult)) {
        // debugger
        monitorResult = monitorResult.replace(formattedLogRegex, '');
      }
      // markDownLogDescription.value = errorCodeMap(dot.serverStatus)
      const monitorFlowRegex = />{8}mct_monitor_flow_begin[\s\S]*?mct_monitor_flow_end<<<<<<<</g;
      if (monitorFlowRegex.test(monitorResult)) {
        monitorResult = monitorResult.replace(monitorFlowRegex, '');
      }
      const monitorDiagnoseRegex = />{8}mct_monitor_diagnose_begin[\s\S]*?mct_monitor_diagnose_end<<<<<<<</g;
      if (monitorDiagnoseRegex.test(monitorResult)) {
        monitorResult = monitorResult.replace(monitorDiagnoseRegex, '');
      }
      const traceLogRegex = /TraceSaved => \<a href\s*=\s*\"(.+?)\"\>/;
      if (traceLogRegex.test(monitorResult)) {
        const traceLogUrl = traceLogRegex.exec(monitorResult)?.[1] || '';
        traceLog.value = traceLogUrl;
        const traceLogRegex1 = /TraceSaved => <a href\s*=\s*"(.+?)">/g;
        const formattedTraceLog = 'TraceSaved => <a class="mct-blue" target="_blank" href="$1">';
        monitorResult = monitorResult.replaceAll(traceLogRegex1, formattedTraceLog);
      }
      const tableJsonRegex = /\[result-json:\s?(.*)\]/;
      if (tableJsonRegex.test(monitorResult)) {
        const tableJson = tableJsonRegex.exec(monitorResult)?.[1] || '';
        const tableData = JSON.parse(tableJson);
        // console.log('@@@tableData', tableData)
        getLogTableData(tableData);
        monitorResult = monitorResult.split(/\[result-json:.*\]/).join('');
      }
      const xmlRegex = /\[result:\s?<\?xml version=["']1\.0["'] encoding=["']utf-8["']\?>([\s\S]*)\]/i;
      if (logFormat.value !== 'TABLE' && xmlRegex.test(monitorResult)) {
        monitorResult = getXmlData(monitorResult);
      }
      getInfoForMctLogAndWireShark(monitorResult);
      incIssueNote.value = monitorResult;
      formatLog(monitorResult);
    };
    const formattedLog = ref([]);
    const formatLog = str => {
      formattedLog.value = [];
      const briefDataRegex = /(\[(?:Station|Pod).+Plugin output:(<br\s*\/?>)*)/;
      const briefDataRegex2 = /\[(?:Station|Pod).+Plugin output:(<br\s*\/?>)*/;
      if (briefDataRegex.test(str)) {
        // @ts-ignore
        const briefDataStr = briefDataRegex.exec(str)[1];
        formatBasicLog(briefDataStr);
        str = str.replace(briefDataRegex2, '');
        const exitCodeRegex = /Plugin exit code:\s(\d+)/;
        if (exitCodeRegex.test(str)) {
          // @ts-ignore
          const exitCode = exitCodeRegex.exec(str)[1];
          formattedLog.value.push({
            key: 'Plugin exit code',
            value: exitCode
          });
          str = str.replace(/Plugin exit code:\s\d+/, '');
        }
      }
      str = str.replaceAll('\\n', '<br>').replaceAll('\\t', '&nbsp;&nbsp;&nbsp;&nbsp;').replaceAll('  ', '&nbsp;&nbsp;').replaceAll('<hr>', '<br />');
      const endBrRegex = /(<br\s*\/?>){3}/g;
      if (endBrRegex.test(str)) {
        str = str.replace(endBrRegex, '<br>');
      }
      markDownLog.value = str;
    };
    const formatBasicLog = log => {
      // console.log('@log', log)
      const logArgRegex = /\[([^\[\]=]+?)\s=\s([^\[\]=]+?)\]/g;
      // @ts-ignore
      const matches = Array.from(log.matchAll(logArgRegex));
      matches.forEach(match => {
        formattedLog.value.push({
          key: match[1],
          value: match[2]
        });
      });
      const commandRegex = /(\[Plugin command line:.+\])/;
      if (commandRegex.test(log)) {
        // @ts-ignore
        const commandLineStr = commandRegex.exec(log)[1];
        // const argsRegex = /\s(-[a-z_]+)[\s:]\"(.+?)\"/g
        if (['KubernetesJobExecutor', 'URL Watch Server'].includes(serverTypeName.value)) {
          const commandRegex = /\[Plugin command line:\s(.+?)\s\-/;
          if (commandRegex.test(commandLineStr)) {
            // @ts-ignore
            const command = commandRegex.exec(commandLineStr)[1];
            formattedLog.value.push({
              key: 'command',
              value: command
            });
          }
          const argsRegex = /\s(-[a-z_]+)[\s:]\"(.*?)\"/g;
          const args = [];
          // @ts-ignore
          const argsMatches = Array.from(commandLineStr.matchAll(argsRegex));
          argsMatches.forEach(match => {
            args.push({
              key: match[1],
              value: match[2]
            });
          });
          formattedLog.value.push({
            key: 'ARGS',
            value: args
          });
        } else {
          const commandWithoutArgsWRegex = /\[Plugin command line:\s(.+?)\]<br/;
          if (commandWithoutArgsWRegex.test(commandLineStr)) {
            // @ts-ignore
            const command = commandWithoutArgsWRegex.exec(commandLineStr)[1];
            formattedLog.value.push({
              key: 'command',
              value: command
            });
          }
        }
      }
      const processIdRegex = /Plugin Process ID \[(\d+?)\]/;
      if (processIdRegex.test(log)) {
        // @ts-ignore
        const processId = processIdRegex.exec(log)[1];
        formattedLog.value.push({
          key: 'Plugin Process ID',
          value: processId
        });
      }
      // }
      // console.log('@@@formattedLog', formattedLog)
    };
    const logFormat = ref('');
    const logTableColumns = ref([]);
    const logTableData = ref([]);
    const logTableRestKeyValue = ref([]);
    const getLogTableData = data => {
      logTableColumns.value = [];
      logTableData.value = [];
      logTableRestKeyValue.value = [];
      let dataArray = [];
      for (const key in data) {
        if (Array.isArray(data[key])) {
          dataArray = data[key];
        } else {
          logTableRestKeyValue.value.push({
            key,
            value: data[key]
          });
        }
      }
      const firstRow = dataArray?.[0];
      const keyCount = Object.keys(firstRow)?.length || 1;
      for (const key in firstRow) {
        logTableColumns.value.push({
          key: key,
          dataKey: key,
          title: key,
          width: Math.floor(1200 / keyCount)
        });
      }
      logTableData.value = dataArray?.map((item, index) => ({
        id: `row-${index}`,
        parentId: null,
        ...item
      }));
      logFormat.value = 'TABLE';
      // console.log('@@@logTableData.value', logTableData.value)
    };
    const xmlData = ref('');
    const getXmlData = str => {
      xmlData.value = '';
      const xmlRegex = /\[result:\s?<\?xml version=["']1\.0["'] encoding=["']utf-8["']\?>([\s\S]*)\]/i;
      xmlData.value = xmlRegex.exec(str)?.[1] || '';
      str = str.replace(/\[result:\s?<\?xml version=["']1\.0["'] encoding=["']utf-8["']\?>[\s\S]*\]/i, '');
      const postDataXmlRegex = /(post data.*?<\?xml version=["']1\.0["'] encoding=["']utf-8["']\?>[\s\S]*?\])/gi;
      const xmlMatches = Array.from(str.matchAll(postDataXmlRegex));
      xmlMatches.forEach(match => {
        str = str.replace(match[1], match[1].replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;'));
      });
      logFormat.value = 'XML';
      return str;
    };
    const removeStyle = str => {
      const styleTag = /<style.*?>(\n|.)*<\/style>/;
      if (styleTag.test(str)) {
        str = str.split(styleTag).join('');
      }
      const linkTag = /<link rel="stylesheet"(\n|.)*?>/;
      if (linkTag.test(str)) {
        str = str.split(linkTag).join('');
      }
      const elLoadingRegex = /<div.+?el-loading.+?<\/div>/g;
      if (elLoadingRegex.test(str)) {
        str = str.replace(elLoadingRegex, '');
      }
      return str;
    };
    const mctLogUrl = ref('');
    const ips = ref('');
    const getInfoForMctLogAndWireShark = str => {
      mctLogUrl.value = '';
      ips.value = '';
      const stationIpRegex = /Station IP\s*=\s*(\d+\.\d+\.\d+\.\d+)/;
      let stationIp = '';
      if (stationIpRegex.test(str)) {
        // @ts-ignore
        stationIp = stationIpRegex.exec(str)[1];
      }
      const lstm = getNumberFromStr(format(add(new Date(currDotTime.value), {
        minutes: -1
      }), 'yyyy-MM-dd HH:mm:ss'));
      const letm = getNumberFromStr(format(add(new Date(currDotTime.value), {
        minutes: 10
      }), 'yyyy-MM-dd HH:mm:ss'));
      const duration = 600;
      const svrtype = serverType.value;
      const svrtypename = encodeURIComponent(serverTypeName.value);
      const zid = zoneId.value;
      const svrid = serverId.value || currServerId.value;
      ips.value = stationIp;
      mctLogUrl.value = `http://${stationIp}:9876/analyse?btm=${lstm}&etm=${letm}&ip={ips}&duration=${duration}&svrtype=${svrtype}&svrtypename=${svrtypename}&zid=${zid}&svrid=${svrid}&manual=0&`;
    };
    const openIncident = async () => {
      const startTime = format(add(new Date(checkStatus.value.gmtStatusTime), {
        hours: -2
      }), 'yyyy-MM-dd HH:mm:00');
      const config = {
        url: '/incident/ticket/prepare',
        method: 'post',
        data: {
          startTime,
          serverIds: selectedFailedDot.value.serverId,
          statusIds: selectedFailedDot.value.statusId
        }
      };
      const {
        object
      } = await mctRequest.request(config);
      incidentTicket.value = object;
      // console.log('data@@@', object)
      incidentDialogVisible.value = true;
    };
    const openIssue = async () => {
      const startTime = format(add(new Date(checkStatus.value.gmtStatusTime), {
        hours: -2
      }), 'yyyy-MM-dd HH:mm:00');
      const config = {
        url: '/issue/prepare',
        method: 'post',
        data: {
          startTime,
          serverIds: selectedFailedDot.value.serverId,
          statusIds: selectedFailedDot.value.statusId
        }
      };
      const {
        object
      } = await mctRequest.request(config);
      issueTicket.value = object;
      // console.log('data@@@', object)
      issueDialogVisible.value = true;
    };
    const clearCache = () => {
      clusterName.value = '';
      checkName.value = '';
      statusDots.value = {};
      currDotTime.value = '';
      markDownLogDescription.value = '';
      markDownLog.value = '';
      shareLink.value = '';
      currTabIndex.value = 'FormattedLog';
      serverType.value = 0;
      serverTypeName.value = '';
      zoneId.value = 0;
      // clear manuel test detail dialog data
      isManualTestDetail.value = false;
      manuelTestDetailDate.value = {};
      formattedLog.value = [];
      logFormat.value = '';
    };
    const init = async () => {
      await getGoupListApi();
      if (isManualTestDetail.value) {
        getStatusMonitorResult(manuelTestDetailDate.value);
      } else if (isManual.value) {
        getStatusDetailByManualId();
      } else {
        getDetailStatusDots();
      }
    };
    watch(isShowDetailStatus, () => {
      if (!isShowDetailStatus.value) {
        clearCache();
      } else {
        init();
      }
    });
    onMounted(() => {
      init();
    });
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_table_v2 = _resolveComponent("el-table-v2");
      const _component_el_auto_resizer = _resolveComponent("el-auto-resizer");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(CheckNameAndOwner, {
        "cluster-name": clusterName.value,
        "cluster-id": clusterId.value,
        "check-name": checkName.value,
        "curr-server-id": _unref(serverId) || currServerId.value
      }, null, 8, ["cluster-name", "cluster-id", "check-name", "curr-server-id"]), !(_unref(isManualTestDetail) || _unref(isManual)) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(statusTimeLabel.value), 1), (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5, 6], i => {
        return _createElementVNode("div", {
          key: i
        }, _toDisplayString(i) + "0m", 1);
      }), 64))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusDots.value, (value, key) => {
        return _openBlock(), _createElementBlock("div", {
          class: "status-dots",
          key: key
        }, [_createElementVNode("div", _hoisted_5, _toDisplayString(key), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (blockStatus, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "status-block",
            key: index
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blockStatus, (dot, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["dot-wrap", dot.maintainStatus ? 'maintained' : ''])
            }, [_createElementVNode("div", {
              class: _normalizeClass(["dot", dotColorMap[dot.icon]]),
              onClick: $event => changeDot(dot)
            }, [(_unref(selectedFailedDot).statusId === dot.statusId ? 'curr-dot' : '') ? (_openBlock(), _createElementBlock("div", _hoisted_7)) : _createCommentVNode("", true)], 10, _hoisted_6)], 2);
          }), 128))]);
        }), 128))]);
      }), 128))])) : _createCommentVNode("", true), _unref(privilege) > 0 ? (_openBlock(), _createBlock(_component_el_menu, {
        key: 1,
        "default-active": currTabIndex.value,
        class: "dot-status-menu",
        mode: "horizontal",
        onSelect: handleSelect
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu_item, {
          index: "FormattedLog"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("Monitor Results")])),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "Incident"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("Incident")])),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "Issue"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("Issue")])),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "PagerDuty"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("PagerDuty")])),
          _: 1
        })]),
        _: 1
      }, 8, ["default-active"])) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [currTabIndex.value === 'FormattedLog' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formattedLog.value, (logRow, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "brief-item",
          key: index
        }, [_createElementVNode("span", null, _toDisplayString(logRow.key?.toUpperCase()), 1), logRow.key !== 'ARGS' ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(logRow.value), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logRow.value, arg => {
          return _openBlock(), _createElementBlock("div", {
            class: "arg-item",
            key: arg.key
          }, [_createElementVNode("div", null, _toDisplayString(arg.key), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(arg.value), 1)]);
        }), 128))]))]);
      }), 128)), _createElementVNode("div", _hoisted_15, [_cache[6] || (_cache[6] = _createElementVNode("span", null, "PLUGIN OUTPUT", -1)), _createElementVNode("div", {
        innerHTML: _unref(markDownLog)
      }, null, 8, _hoisted_16), logFormat.value === 'TABLE' ? (_openBlock(), _createElementBlock("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logTableRestKeyValue.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "table-rest-key-value"
        }, [_createElementVNode("span", _hoisted_18, _toDisplayString(item.key), 1), _createElementVNode("span", null, _toDisplayString(item.value), 1)]);
      }), 128)), _createVNode(_component_el_auto_resizer, null, {
        default: _withCtx(() => [_createVNode(_component_el_table_v2, {
          columns: logTableColumns.value,
          data: logTableData.value,
          "estimated-row-height": 40,
          width: 1200,
          height: 400,
          fixed: ""
        }, null, 8, ["columns", "data"])]),
        _: 1
      })])) : logFormat.value === 'XML' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_unref(XmlViewer), {
        xml: xmlData.value
      }, null, 8, ["xml"])])) : _createCommentVNode("", true)])])]), _createVNode(DownloadAndShareInfo, {
        "mct-log-url": mctLogUrl.value,
        ips: ips.value,
        "run-book": runBook.value,
        "trace-log": traceLog.value,
        "share-link": shareLink.value
      }, null, 8, ["mct-log-url", "ips", "run-book", "trace-log", "share-link"])])) : currTabIndex.value === 'SourceLog' ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", {
        innerHTML: _unref(markDownLog)
      }, null, 8, _hoisted_21), _createVNode(DownloadAndShareInfo, {
        "mct-log-url": mctLogUrl.value,
        ips: ips.value,
        "run-book": runBook.value,
        "trace-log": traceLog.value,
        "share-link": shareLink.value
      }, null, 8, ["mct-log-url", "ips", "run-book", "trace-log", "share-link"])])) : currTabIndex.value === 'Incident' ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(IncidentTable, {
        "server-id": _unref(serverId)
      }, null, 8, ["server-id"]), _createVNode(_component_el_button, {
        class: "mt-10",
        onClick: openIncident
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("Open Incident")])),
        _: 1
      })])) : currTabIndex.value === 'Issue' ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(IssueTable, {
        "server-id": _unref(serverId)
      }, null, 8, ["server-id"]), _createVNode(_component_el_button, {
        class: "mt-10",
        onClick: openIssue
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("Open Issue")])),
        _: 1
      })])) : currTabIndex.value === 'PagerDuty' ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(PagerDutyTable, {
        "server-id": _unref(serverId)
      }, null, 8, ["server-id"])])) : _createCommentVNode("", true)])), [[_directive_loading, loading.value]]), _createVNode(_component_el_dialog, {
        modelValue: _unref(incidentDialogVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(incidentDialogVisible) ? incidentDialogVisible.value = $event : null),
        "show-close": false,
        width: "50%"
      }, {
        header: _withCtx(({
          close
        }) => [_createVNode(DialogHeader, {
          onClose: close,
          "header-name": "New Incident"
        }, null, 8, ["onClose"])]),
        default: _withCtx(() => [_createVNode(Incident, {
          "cluster-id": clusterId.value
        }, null, 8, ["cluster-id"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(issueDialogVisible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(issueDialogVisible) ? issueDialogVisible.value = $event : null),
        "show-close": false,
        width: "50%"
      }, {
        header: _withCtx(({
          close
        }) => [_createVNode(DialogHeader, {
          onClose: close,
          "header-name": "New Issue"
        }, null, 8, ["onClose"])]),
        default: _withCtx(() => [_createVNode(Issue, {
          "cluster-id": clusterId.value
        }, null, 8, ["cluster-id"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});